<template lang="pug">
el-dialog(v-dialogDrag title="新建模块" :visible.sync="dataDialog" width="400px" :before-close="handleClose" @close="close")
  el-form(ref="form" :model="form" label-width="100px" size="small" label-position="top" :rules="rules")
    el-form-item(label="模块名称" prop="groupName")
      el-input(v-model="form.groupName" ref="groupNameFocus" clearable maxlength="30" show-word-limit)
    el-form-item(label="模块编号" prop="groupId")
      el-input(v-model="form.groupId" clearable maxlength="20" show-word-limit)
    el-form-item(label="表单页描述" prop="remark")
      el-input(v-model="form.remark" type="textarea" maxlength="50" show-word-limit)
  div(slot="footer")
    el-button(@click="handleClose" size="small") 取 消
    el-button(type="primary" @click="onSubmit" size="small") 确 定
</template>

<script>
import metadataService from "@/CommonDP/service/metadata-service.js";
export default {
  data () {
    return {
      dataDialog: false,
      form: {
        groupId: '',
        groupName: '',
        parentId: '',
        remark: ''
      },
      rules: {
        groupName: [{ required: true, message: '请填写模块名称', trigger: 'blur' }],
        groupId: [{ required: true, message: '请填写模块编号', trigger: 'blur' }]
      }
    };
  },
  methods: {
    // 添加
    async addForm(data) {
      this.form.parentId = data?.groupId;
      this.dataDialog = true;
      await this.$nextTick();
      this.$refs.groupNameFocus.focus();
    },
    handleClose() {
      this.dataDialog = false;
    },
    // 校验表单数据
    async validateFormData() {
      let flag = null;
      await this.$refs.form
        .validate()
        .then(() => {
          flag = true; // 验证通过
        })
        .catch(() => {});
      return flag;
    },
    /** @description: 新增参数描述
     * @param {groupId} 模块编号
     * @param {groupName} 模块名称
     * @param {parentId} 父ID
     * @param {remark} 描述
     */
    async onSubmit() {
      const validate = await this.validateFormData();
      if(validate){
        const { groupId, groupName, parentId, remark } = this.form;
        const params = {
          groupId, groupName, parentId, remark
        };
        try {
          await metadataService.dynFormGroupSave(params);
          this.$success("添加成功!");
          this.$emit('initTree');
          this.form = {};
          this.dataDialog = false;
        } catch (error) {
          console.log(error);
        }
      }
    },
    // 关闭事件
    close(){
      this.form = {
        groupId: '',
        groupName: '',
        parentId: '',
        remark: ''
      };
      this.$refs.form.clearValidate();
    }
  }
};
</script>

<style lang="scss" scoped></style>

